import Container from 'typedi'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import EventProductService from '@/modules/level-two/services/event-product.service'
import { AvailablePlatformProduct, EventProduct } from '@/modules/level-two/interfaces/event-product.interface'

@Module({
  namespaced: true
})
export default class EventProductStore extends VuexModule {
  event_products: EventProduct[] = []
  available_platform_products: AvailablePlatformProduct[] = []

  @Mutation
  SET_EVENT_PRODUCTS (payload: EventProduct[]) {
    this.event_products = payload
  }

  @Mutation
  SET_AVAILABLE_PLATFORM_PRODUCTS (payload: AvailablePlatformProduct[]) {
    this.available_platform_products = payload
  }

  @Action({ rawError: true })
  async fetchEventProducts (eventUuid: string) {
    const response: any = await Container.get(EventProductService).getEventProducts(eventUuid)
    this.context.commit('SET_EVENT_PRODUCTS', response.data.event_products)
    this.context.commit('SET_AVAILABLE_PLATFORM_PRODUCTS', response.data.available_platform_products)
    return response.data
  }

  @Action({ rawError: true })
  async createEventProduct (payload: { eventUuid: string, data: any }) {
    const response = await Container.get(EventProductService).createEventProduct(payload.eventUuid, payload.data)
    await this.context.dispatch('fetchEventProducts', payload.eventUuid)
    return response
  }

  @Action({ rawError: true })
  async updateEventProduct (payload: { eventUuid: string, uuid: string, data: any }) {
    const response = await Container.get(EventProductService).updateEventProduct(payload.eventUuid, payload.uuid, payload.data)
    await this.context.dispatch('fetchEventProducts', payload.eventUuid)
    return response
  }

  @Action({ rawError: true })
  async deleteEventProduct (payload: { eventUuid: string, uuid: string }) {
    const response = await Container.get(EventProductService).deleteEventProduct(payload.eventUuid, payload.uuid)
    await this.context.dispatch('fetchEventProducts', payload.eventUuid)
    return response
  }

  @Action({ rawError: true })
  async reorderEventProducts (payload: { eventUuid: string, items: Array<{ uuid: string, display_order: number }> }) {
    const response = await Container.get(EventProductService).reorderEventProducts(payload.eventUuid, payload.items)
    await this.context.dispatch('fetchEventProducts', payload.eventUuid)
    return response
  }
}
